import i18next from 'i18next';
import LocaleKeys from '../locales/keys';

export const addNewAddressConstant = () => {
  const addNewAddress = [
    {
      Id: 0,
      displayName: i18next.t(
        LocaleKeys.subscriptionInfo.subscriptions.paymentFormAddNewAddress,
      ),
    },
  ];
  return addNewAddress;
};
